<template>
  <div>
    <VueSlider
      v-model="internalSelected"
      :adsorb="true"
      :data="speedData"
      :tooltip="'none'"
      :tooltip-placement="'bottom'"
      @change="selectAndEmit"
    />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

export default {
  name: "SpeedChooserMulti",
  components: {
    VueSlider
  },
  props: {
    data: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    //optional value subIndex for parts where multiple values need to be pickable
    subIndex: { type: Number, default: null },
    selected: { type: Array, default: () => [] }
  },
  data() {
    return {
      internalSelected: "",
      speedData: []
    };
  },
  watch: {
    selected: {
      handler: function(newVal) {
        if (typeof newVal !== []) {
          if (newVal[this.subIndex])
            this.internalSelected = newVal[this.subIndex].value_description;
          else this.internalSelected = "normal";
        } else {
          this.internalSelected = "normal";
          this.selectAndEmit(this.internalSelected);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.mapData();
  },
  methods: {
    mapData() {
      let dataArray = [];
      for (let i = 0; i < this.data.length; i++) {
        dataArray.push(this.data[i].value_description);
      }
      this.speedData = dataArray;
    },
    selectAndEmit(newVal) {
      this.$emit(
        "input",
        this.data.find(x => x.value_description === newVal),
        this.index,
        this.subIndex
      );
    }
  }
};
</script>

<style scoped></style>
